import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocaleService {

  private currentLocale = new BehaviorSubject<string>('en')

  constructor(@Inject(DOCUMENT) private document: Document) { }

  setLocale(locale: string) {
    this.currentLocale.next(locale);
    this.updateLocale(locale)
  }

  getLocale() {
    return this.currentLocale.asObservable();
  }

  locale() {
    return this.currentLocale.getValue();
  }

  private updateLocale(locale: string) {
    this.document.documentElement.lang = locale;
  }
}
